<label for="{{id}}" class="app-component-container"
  [ngClass]="{'size-sm': size.toLowerCase()=='sm', 'size-md': size.toLowerCase()=='md', 'size-lg': size.toLowerCase()=='lg'}">
  <div class="border-silver app-checkbox-containter rouded border"
  [ngClass]="{'bg-light': disabled, 'bg-white': !disabled, 'focus': focus && outline}">
    <i class="mdi mdi-check {{color}}" [ngClass]="{'checked': checked, 'unchecked': !checked, 'disabled text-muted': disabled}"></i>
  </div>
  <div class="pl-3 checkbox-label" *ngIf="label!=''">
    {{label}}
  </div>
  <input (change)="toggle()" [value]="checked" (focus)="focus=true" (blur)="focus=false" type="checkbox" id="{{id}}">
</label>
